import axios from 'axios'
import Cookies from 'js-cookie'
// 创建axios实例
const axiosInstance = axios.create({
  // baseURL: 'http://tianjin.cafetime.cc:23286/cmp-service/front',
  timeout: 3 * 60 * 1000,
  withCredentials: true,
});
// var token =  Cookies.get('teaching-cmp-test-token')
// var tokenName =  'teaching-cmp-test-token';
axiosInstance.defaults.withCredentials = true;
axiosInstance.interceptors.request.use(
  (config) => {
    // let header = {
    //   'Cookie': tokenName + '=' + token + ';Path=/; httponly; secure; SameSite=None;',
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }
    // config.headers = header,
    // console.log("config",config)
    // Do something before request is sent
    const token = Cookies.get('teaching-cmp-test-token') || '80e79ed3d8587f6e550772664cca4216'
    // const token ='80e79ed3d8587f6e550772664cca4216'
    if (token) {
      config.headers['teaching-cmp-test-token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {}
);
export default axiosInstance
